import type { StoreValues } from 'types/store';

export type FeatureState =
  | 'active'
  | 'inactive'
  | 'pending'
  | 'unknown'
  | 'loading';

type FeatureStatusInput = {
  storeId?: string | null;
  store?: Partial<StoreValues>;
  loading?: boolean;
  guarantee?: {
    loading?: boolean;
    unavailable?: boolean;
    feeConfigured?: boolean;
    embedEnabled?: boolean;
  };
};

export const detectFeatureState = (
  featureId: string,
  { storeId, store, loading, guarantee }: FeatureStatusInput,
): FeatureState => {
  if (loading) return 'loading';
  if (!storeId || !store) return 'unknown';
  if (store.id !== storeId) return 'loading';

  if (featureId === 'returns-exchanges') {
    const enabled = [
      store.resolvePortalOptions?.returnFilingEnabled,
      store.resolvePortalOptions?.returnsEnabled,
      store.resolvePortalOptions?.returns?.enabled,
      store.policySettings?.returns?.enabled,
    ].find((value) => typeof value === 'boolean');
    return typeof enabled === 'boolean'
      ? enabled
        ? 'active'
        : 'inactive'
      : 'unknown';
  }

  if (featureId === 'impact') {
    const trees = store.greenProtection?.enabled;
    const gifts = store.freeGifts?.enabled;
    if (trees === true || gifts === true) return 'active';
    return trees === false && gifts === false ? 'inactive' : 'unknown';
  }

  if (featureId === 'delivery-guarantee') {
    if (guarantee?.loading) return 'loading';
    if (!guarantee || guarantee.unavailable) return 'unknown';
    if (store.uninstalledAt) return 'inactive';
    return store.store &&
      (store.billing || store.plan?.chargeConfirmed) &&
      guarantee.feeConfigured === true &&
      guarantee.embedEnabled === true
      ? 'active'
      : 'pending';
  }

  return 'unknown';
};
